import gsap from 'gsap';
import CustomEase from "../../../../js/vendors/gsap/CustomEase.js";
import CustomWiggle from "../../../../js/vendors/gsap/CustomWiggle.js";

gsap.registerPlugin(CustomEase, CustomWiggle);

const easeTagWiggle = CustomWiggle.create("tagWiggle", {wiggles: 4, type: "easeOut"});
export class MapPopover {
    constructor(container, config = {}) {
        this.container = container;
        this.config = {
            offsetX: config.offsetX || 54,
            offsetY: config.offsetY || 0,
            animationDuration: config.animationDuration || 0.5,
            fadeOutDuration: config.fadeOutDuration || 0.3
        };

        this.element = null;
    }

    create(cityData, position, rotation) {
        this.remove();

        this.element = document.createElement('div');
        this.element.className = 'luggage-tag';

        this.element.innerHTML = `
        <div class="inner">
            <div class="name">&nbsp;</div>
            <div class="desc">${cityData.stats.intro}</div>
        </div>
    `;

        this.element.style.position = 'absolute';
        this.element.style.opacity = '0';
        this.container.appendChild(this.element);

        const tagWidth = this.element.offsetWidth + 50;
        const tagHeight = this.element.offsetHeight;
        const screenWidth = window.innerWidth;
        this.orientation = (position.x + this.config.offsetX + tagWidth) > screenWidth;

        const centerY = position.y - (tagHeight / 2);

        if (this.orientation) {
            this.element.classList.add('reverse');
            this.element.style.left = `${position.x - this.config.offsetX - tagWidth}px`;
        } else {
            this.element.style.left = `${position.x + this.config.offsetX}px`;
        }

        this.element.style.top = `${centerY}px`;

        gsap.to(this.element, {
            opacity: 1,
            x: 0,
            duration: this.config.animationDuration,
            ease: "power2.out"
        });

        gsap.fromTo(this.element, {
            rotation: rotation
        },{
            rotation: rotation + 10,
            duration: 2,
            ease: easeTagWiggle
        });

        /* const partnersElement = this.element.querySelector('.dd');
        const targetNumber = parseInt(cityData.stats.partners);
        const numDigits = Math.max(Math.floor(Math.log10(targetNumber)) + 1, 1);
        const initialZeros = '0'.repeat(numDigits);
        partnersElement.textContent = initialZeros;

        gsap.to({value: 0}, {
            value: targetNumber,
            duration: 1.5,
            ease: "power2.out",
            onUpdate: function() {
                const currentValue = Math.floor(this.targets()[0].value);
                partnersElement.textContent = String(currentValue).padStart(numDigits, '0');
            }
        });
        */

        const nameElement = this.element.querySelector('.name');
        // cityData.country in uppercase
        const nameText = cityData.country.toUpperCase();
        let currentText = '';

        const cursorSpan = document.createElement('span');
        cursorSpan.className = 'typing-cursor';
        cursorSpan.textContent = '|';
        nameElement.appendChild(cursorSpan);

        gsap.to({}, {
            duration: 1,
            onUpdate: function() {
                const progress = this.progress();
                const charIndex = Math.floor(nameText.length * progress);
                currentText = nameText.substring(0, charIndex);
                nameElement.childNodes[0].textContent = currentText || '\u00A0'; // non-breaking space if empty
            },
            onComplete: function() {
                gsap.to(cursorSpan, {
                    opacity: 0,
                    duration: 0.3,
                    onComplete: () => cursorSpan.remove()
                });
            }
        });

        gsap.to(cursorSpan, {
            opacity: 0,
            duration: 0.5,
            repeat: -1,
            yoyo: true
        });

        return this.element;
    }

    remove() {
        if (this.element) {
            return new Promise(resolve => {
                gsap.to(this.element, {
                    opacity: 0,
                    x: this.orientation ? 20 : -20,
                    duration: this.config.fadeOutDuration,
                    ease: "power2.in",
                    onComplete: () => {
                        this.element.remove();
                        this.element = null;
                        resolve();
                    }
                });
            });
        }
        return Promise.resolve();
    }

    updatePosition(position, rotation) {
        if (this.element) {
            const tagWidth = this.element.offsetWidth + 50;
            const tagHeight = this.element.offsetHeight;
            const screenWidth = window.innerWidth;
            const newOrientation = (position.x + this.config.offsetX + tagWidth) > screenWidth;

            // Check if orientation needs to change
            if (newOrientation !== this.orientation) {
                this.orientation = newOrientation;
                if (this.orientation) {
                    this.element.classList.add('reverse');
                } else {
                    this.element.classList.remove('reverse');
                }
            }

            const centerY = position.y - (tagHeight / 2);
            const targetX = this.orientation ? 
                position.x - this.config.offsetX - tagWidth :
                position.x + this.config.offsetX;

            gsap.to(this.element, {
                left: targetX,
                top: centerY,
                duration: 0.3,
                ease: "power2.out"
            });
        }
    }
}
